import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const DEFAULT_PAGE_SIZE = 8;
export const PAGE_SIZE_OPTIONS = [50, 100, 200];

export function paginate(items, currentPage, pageSize = DEFAULT_PAGE_SIZE) {
  const size = pageSize || DEFAULT_PAGE_SIZE;
  const totalPages = Math.max(1, Math.ceil(items.length / size));
  const safePage = Math.min(Math.max(1, currentPage || 1), totalPages);
  const start = (safePage - 1) * size;
  const paginatedItems = items.slice(start, start + size);
  return { paginatedItems, totalPages, safePage };
}

export function Pagination({
  currentPage,
  totalPages,
  onPageChange,
  pageSize,
  onPageSizeChange,
  pageSizeOptions = PAGE_SIZE_OPTIONS,
}) {
  const showSizePicker = typeof pageSize === "number" && typeof onPageSizeChange === "function";
  if (totalPages <= 1 && !showSizePicker) return null;
  return (
    <div className="flex items-center justify-between pt-3 px-1 gap-3 flex-wrap" data-testid="pagination">
      <div className="flex items-center gap-3">
        <p className="text-xs text-muted-foreground">
          Page {currentPage} of {totalPages}
        </p>
        {showSizePicker && (
          <div className="flex items-center gap-1.5" data-testid="pagination-page-size">
            <span className="text-xs text-muted-foreground">Rows:</span>
            <Select
              value={String(pageSize)}
              onValueChange={(v) => onPageSizeChange(parseInt(v, 10))}
            >
              <SelectTrigger className="h-8 w-[76px] text-xs" data-testid="pagination-page-size-trigger">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {pageSizeOptions.map((opt) => (
                  <SelectItem key={opt} value={String(opt)} data-testid={`pagination-page-size-option-${opt}`}>
                    {opt}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        )}
      </div>
      <div className="flex items-center gap-1.5">
        <Button
          variant="outline"
          size="sm"
          className="h-8 text-xs gap-1"
          disabled={currentPage <= 1}
          onClick={() => onPageChange(currentPage - 1)}
          data-testid="pagination-prev"
        >
          <ChevronLeft className="w-3.5 h-3.5" /> Previous
        </Button>
        <Button
          variant="outline"
          size="sm"
          className="h-8 text-xs gap-1"
          disabled={currentPage >= totalPages}
          onClick={() => onPageChange(currentPage + 1)}
          data-testid="pagination-next"
        >
          Next <ChevronRight className="w-3.5 h-3.5" />
        </Button>
      </div>
    </div>
  );
}
